// Test-Schnittstelle für E2E-Tests und den Durchspiel-Bot (window.__dlr).
// Liefert nur Positionen/Zustände; Eingaben macht der Bot über echte Klicks/Taps.
import { t, has } from '../i18n.ts';
import { get } from 'svelte/store';
import { game } from './game.ts';
import { ui } from './store.ts';
import { missing } from '../i18n.ts';
import { audio } from '../audio/audio.ts';

export function installTestApi() {
  (window as any).__dlrGame = game;
  (window as any).__dlr = {
    get ready() {
      return game.ready;
    },
    get busy() {
      const s = get(ui);
      return game.busy || game.view.walking || !!s.speech;
    },
    scene: () => game.state?.scene,
    state: () => JSON.parse(JSON.stringify(game.state)),
    hotspots: () =>
      game.activeHotspots().map((h) => {
        const r = game.view.hotspotRect(h)!;
        const c = game.view.worldToScreen({ x: r[0] + r[2] / 2, y: r[1] + r[3] / 2 });
        return { id: h.id, name: game.hotspotName(h), x: c.x, y: c.y, inView: game.view.inView(c.x, c.y) };
      }),
    /** Kamera so verschieben, dass ein Hotspot sichtbar ist */
    focus: (id: string) => {
      const h = game.activeHotspots().find((x) => x.id === id);
      if (!h) return false;
      const r = game.view.hotspotRect(h)!;
      const visW = game.view.viewRect.w / game.view.scale;
      const target = Math.max(0, Math.min(game.view.def.width - visW, r[0] + r[2] / 2 - visW / 2));
      game.view.manualPan = target - (game.view.player.x - visW / 2);
      game.view.camX = target;
      return true;
    },
    answer: (qid: string) => {
      const q = game.questions.get(qid);
      return q ? JSON.parse(JSON.stringify(q)) : null;
    },
    speechLog: () => [...game.speechLog],
    dbg: () => ({ busy: game.busy, walking: game.view.walking, speech: !!get(ui).speech, player: [Math.round(game.view.player.x), Math.round(game.view.player.y)] }),
    goto: (id: string, spawn?: string) => game.enterScene(id, spawn),
    /** übersetzter Text oder null */
    text: (k: string) => (has(k) ? t(k) : null),
    setFlags: (f: Record<string, any>) => { Object.assign(game.state.flags, f); game.refresh(); },
    dialog: () => get(ui).dialog,
    save: (slot: any) => game.saveTo(slot),
    audioState: () => ({ ctx: (audio as any).ctx?.state ?? 'none', ambience: (audio as any).currentAmbience, music: (audio as any).currentMusic }),
    savedAt: () => game.savedAt,
    missingKeys: () => [...missing],
    fast: (on = true) => ((window as any).__dlrFast = on),
  };
}
